let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4tlRi")).then(() => parcelRequire('5LmZi'));